var _g, _g2, _path, _path2, _path3, _g3, _path4, _path5, _g4, _g5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 238,
    viewBox: "0 0 291 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.955 237.875C175.022 240.186 160.679 208.959 89.7964 221.933C33.2753 232.277 8.94286 193.657 1.90439 169.664C-1.45488 158.2 -2.30803 113.395 28.7074 112.755C133.965 110.552 218.302 -5.57524 269.046 95.978C289.628 137.175 321.959 232.615 219.955 237.875Z",
    fill: "#F4EFFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_73_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.002 148.764C89.7986 179.243 116.936 213.346 150.682 213.575C184.441 213.803 212.036 180.082 212.239 149.59C212.443 119.11 185.191 103.4 151.432 103.171C117.673 102.942 90.2053 118.271 89.9893 148.751L90.002 148.764Z",
    fill: "url(#paint0_linear_73_3600)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.26 118.474L191.249 118.479C184.905 121.644 182.327 129.353 185.491 135.697L203.68 172.163C206.845 178.507 214.554 181.085 220.898 177.92L220.91 177.915C227.254 174.75 229.832 167.041 226.667 160.697L208.478 124.231C205.314 117.887 197.605 115.309 191.26 118.474Z",
    fill: "url(#paint1_linear_73_3600)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.038 27.5054L86.4173 17.4386C79.8078 14.3627 72.029 15.2016 66.2203 19.6248C56.4332 27.0859 49.633 37.8009 47.0655 49.8378C42.7948 69.7806 53.7258 89.8632 72.7916 97.1082L93.9928 105.167L108.038 27.5181V27.5054Z",
    fill: "#9E83FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.521 39.3261L87.5486 30.9499C82.0449 28.3824 75.5753 29.0815 70.758 32.7675C62.6232 38.9702 56.9671 47.8803 54.8317 57.8835C51.2854 74.4708 60.3608 91.1597 76.2235 97.1845L93.853 103.883L105.534 39.3261H105.521Z",
    fill: "url(#paint2_linear_73_3600)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_73_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0153 74.4709C91.6162 73.9243 97.1962 81.4617 93.7135 89.5837L91.7306 94.1976C89.8622 98.5573 86.0744 107.633 89.608 110.785L100.768 122.428C112.36 139.193 101.619 149.438 97.1072 149.997C82.6807 151.751 65.7122 120.496 65.7122 120.496C60.5644 110.937 64.9368 102.765 67.4662 96.4092C71.0887 87.2577 77.5838 74.9539 84.0153 74.4836V74.4709Z",
    fill: "url(#paint3_linear_73_3600)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.403 19.6757L197.278 5.09669C203.049 0.635295 210.828 -0.254442 217.463 2.78337C228.648 7.90572 237.634 16.8666 242.795 28.0392C251.349 46.5584 245.095 68.5477 228.089 79.8092L209.176 92.329L178.403 19.6757Z",
    fill: "#9E83FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.462 30.6575L199.16 18.5316C203.964 14.8201 210.421 14.0829 215.938 16.6123C225.242 20.8703 232.716 28.3187 236.999 37.6101C244.104 53.0026 238.918 71.293 224.772 80.648L209.049 91.0579L183.462 30.6575Z",
    fill: "url(#paint4_linear_73_3600)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_73_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.45 75.7798C221.606 113.111 193.211 133.219 155.88 137.375C118.549 141.531 86.4297 128.16 82.2734 90.8291C78.1171 53.4982 115.321 8.76989 141.25 5.8846C167.18 2.9993 213.294 38.449 217.45 75.7798Z",
    fill: "url(#paint5_linear_73_3600)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_73_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.409 12.3036C133.878 16.2185 135.467 29.5137 135.467 29.5137C135.658 29.9586 136.281 29.7298 136.484 29.5773C137.336 28.8909 139.166 26.0564 139.166 26.0564C139.395 25.6497 139.967 25.6751 140.17 26.0946C140.17 26.0946 142.115 30.7593 142.903 35.0682C142.954 35.3478 143.767 35.1063 143.97 34.9157C145.826 33.2379 146.627 25.0777 146.627 25.0777C146.716 24.6202 147.25 24.4422 147.58 24.76C147.58 24.76 149.97 25.5353 151.508 28.5223C151.622 28.7511 152.296 28.357 152.461 28.1664C155.842 24.2897 156.694 10.9182 153.414 7.15589C148.75 1.80475 121.409 8.69386 127.421 12.3291L127.409 12.3036Z",
    fill: "#8058EA"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.412 106.349C179.789 97.2226 189.119 91.7571 198.245 94.1339",
    stroke: "#806CFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.865 97.9147C134.679 96.7112 142.186 84.4241 140.634 70.4706C139.081 56.517 129.056 46.181 118.242 47.3845C107.428 48.5879 99.9199 60.875 101.473 74.8286C103.026 88.7821 113.051 99.1181 123.865 97.9147Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.953 64.4292C195.474 69.1702 193.491 76.4407 193.491 76.4407L160.495 80.7622C160.495 80.7622 156.389 73.7206 155.792 68.7889C154.088 54.8582 161.74 42.5544 172.557 41.3469C183.374 40.1394 193.402 50.4731 194.953 64.4292Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.628 70.4668C141.149 75.2078 139.166 82.4783 139.166 82.4783L106.17 86.7998C106.17 86.7998 102.064 79.7582 101.467 74.8265C99.7637 60.8958 107.415 48.592 118.232 47.3845C129.049 46.177 139.077 56.5107 140.628 70.4668Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.301 52.0496C185.388 47.5233 180.168 45.4047 175.642 47.3176C171.116 49.2305 168.997 54.4505 170.91 58.9768L173.384 64.8307C175.297 69.357 180.517 71.4755 185.043 69.5626C189.569 67.6497 191.688 62.4298 189.775 57.9035L187.301 52.0496Z",
    fill: "#122431"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.386 57.0316C182.843 57.0316 184.835 55.0399 184.835 52.583C184.835 50.126 182.843 48.1343 180.386 48.1343C177.929 48.1343 175.938 50.126 175.938 52.583C175.938 55.0399 177.929 57.0316 180.386 57.0316Z",
    fill: "#FEFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.868 58.1794C130.955 53.6532 125.735 51.5346 121.209 53.4475C116.682 55.3604 114.564 60.5804 116.477 65.1067L118.951 70.9606C120.864 75.4869 126.084 77.6054 130.61 75.6925C135.136 73.7796 137.255 68.5596 135.342 64.0334L132.868 58.1794Z",
    fill: "#122431"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.947 63.1459C128.404 63.1459 130.396 61.1542 130.396 58.6972C130.396 56.2403 128.404 54.2485 125.947 54.2485C123.49 54.2485 121.499 56.2403 121.499 58.6972C121.499 61.1542 123.49 63.1459 125.947 63.1459Z",
    fill: "#FEFFFF"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_73_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.221 141.836L103.17 138.595C103.132 136.142 105.204 134.032 107.644 134.337C107.809 134.363 114.889 138.887 118.499 139.396C122.477 139.968 128.159 137.133 130.447 129.736C133.472 119.949 128.82 109.768 131.069 103.4C135.022 92.2271 145.026 88.1597 154.635 90.1807C164.257 92.2017 171.387 101.913 170.866 111.789C170.345 121.665 158.982 139.307 152.042 146.234C143.513 154.75 130.828 155.716 124.511 154.788C114.419 153.314 105.076 147.607 105.076 147.607C102.026 146.781 102.217 143.946 103.233 141.836H103.221Z",
    fill: "url(#paint6_linear_73_3600)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_73_3600",
    x: 81.9893,
    y: 98.1685,
    width: 138.251,
    height: 126.407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_3600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_3600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_73_3600",
    x: 51.3164,
    y: 64.4429,
    width: 62.6577,
    height: 95.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0 0 0 0 0 0.447059 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_3600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_3600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_73_3600",
    x: 73.9531,
    y: 0.719727,
    width: 151.901,
    height: 148.384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_3600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_3600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_73_3600",
    x: 124.562,
    y: 4.19189,
    width: 32.9189,
    height: 34.0034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_3600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_3600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_73_3600",
    x: 94.564,
    y: 84.6821,
    width: 84.3291,
    height: 81.3911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_3600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_3600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73_3600",
    x1: 151.126,
    y1: 103.183,
    x2: 151.125,
    y2: 213.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_73_3600",
    x1: 196.398,
    y1: 116.578,
    x2: 194.103,
    y2: 177.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_73_3600",
    x1: 108.291,
    y1: 64.2958,
    x2: 54.4259,
    y2: 70.2901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_73_3600",
    x1: 80.0913,
    y1: 147.1,
    x2: 93.8281,
    y2: 75.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_73_3600",
    x1: 186.237,
    y1: 55.6012,
    x2: 240.115,
    y2: 49.6054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_73_3600",
    x1: 155.883,
    y1: 137.376,
    x2: 141.251,
    y2: 5.89601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_73_3600",
    x1: 155.538,
    y1: 90.089,
    x2: 122.284,
    y2: 156.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_3600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290.39,
    height: 183.61,
    fill: "white",
    transform: "translate(0.304688 54.3901)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.dcbc8376a3d0663cda94cda76dd59f3e.svg";
export { ForwardRef as ReactComponent };